import {
  JQL_SEARCH,
  JIRA_CF_FIELDS,
  JIRA_ISSUE,
  JIRA_LICENSE,
  JIRA_PROJECT,
  JIRA_ISSUE_TYPE,
  JIRA_USER_INFO,
  JIRA_ADMIN_PERMISSION,
  APP_WEB_LOCATION_IN_JIRA,
} from "./types";
import { get } from "../../connections/atlassian/ap";
import { getJiraBaseURL } from "../../env/stage";
import { getAppWebLocationInJira } from "../../connections/atlassian/ap";
import { post } from "../../connections/atlassian/ap";

const JQL_SEARCH_URL = getJiraBaseURL() + "/rest/api/3/search/jql";
const JQL_PARSE_URL = getJiraBaseURL() + "/rest/api/3/jql/parse";
const FIELDS_URL = getJiraBaseURL() + "/rest/api/3/field";
const PROJECT_URL = getJiraBaseURL() + "/rest/api/3/project/search";
const ISSUE_URL = getJiraBaseURL() + "/rest/api/3/issue";
const JIRA_ISSUE_TYPES_URL = getJiraBaseURL() + "/rest/api/3/issuetype";
const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
const JIRA_LICENSE_URL = getJiraBaseURL() + "/rest/atlassian-connect/1/addons/se.rixter.jira.restful.integrator.restful_integrator";
const JIRA_USER_GROUPS = getJiraBaseURL() + "/rest/api/3/myself?expand=groups";
const JIRA_USER_ADMIN_PERMISSION = getJiraBaseURL() + "/rest/api/2/mypermissions?permissions=ADMINISTER";
const JIRA_GET_USER_URL = getJiraBaseURL() + "/rest/api/3/user";
/**
 * General note about AP it returns a Promis in that promis you must call then(data=>data.body) to get hold of the data, it is always in a body property of the data returned
 */
export const checkJiraLicense = () => (dispatch: any) => {
  if (IS_DEVELOPMENT) {
    dispatch({
      type: JIRA_LICENSE,
      payload: {
        key: "se.rixter.jira.restful.integrator.restful_integrator",
        version: "1.0",
        name: "Integrations Hub for Jira",
        installedDate: "2024-08-20T14:56:05Z",
        lastUpdated: "2024-05-10T07:12:44Z",
        state: "ENABLED",
        host: { product: "JIRA" },
        links: {
          marketplace: [{ href: "https://marketplace.atlassian.com/plugins/se.rixter.jira.restful.integrator.restful_integrator" }],
          self: [
            {
              href: "https://rixterdev.atlassian.net/rest/atlassian-connect/1/addons/se.rixter.jira.restful.integrator.restful_integrator",
            },
          ],
        },
      },
    });
  } else {
    get(JIRA_LICENSE_URL)
      .then((res) => {
        //console.log("check license", body);
        dispatch({
          type: JIRA_LICENSE,
          payload: getResponseBody(res),
        });
      })
      .catch((e) => {
        const error = JSON.parse(e.err);
        console.log("check license", error);

        dispatch({
          type: JIRA_LICENSE,
          payload: { isValid: false, errors: error?.errorMessages },
        });
      });
  }
};
export const runJQL = (jqlQuery: string) => (dispatch: any) => {
  const SEARCH = JQL_PARSE_URL + "?validation=strict";
  post(SEARCH, {
    queries: [jqlQuery],
  })
    .then((res) => {
      let isValid = true;
      let errorText = "";
      if (res?.queries?.[0]?.errors) {
        isValid = false;
        errorText = res?.queries?.[0]?.errors;
      }
      const body = { ...res, ...{ isValid: isValid, errors: errorText } };
      dispatch({
        type: JQL_SEARCH,
        payload: body,
      });
    })
    .catch((e) => {
      dispatch({
        type: JQL_SEARCH,
        payload: { isValid: false, errors: e },
      });
    });
};
export const getCustomFields = () => (dispatch: any) => {
  get(FIELDS_URL).then((res) => {
    dispatch({
      type: JIRA_CF_FIELDS,
      payload: getResponseBody(res),
    });
  });
};
export const getIssue = (issueKey: string) => (dispatch: any) => {
  get(ISSUE_URL + "/" + issueKey)
    .then((res) => {
      const body = JSON.parse(res.body);

      let result = { issue: { key: body.key } };
      result.issue = { ...result.issue, ...body.fields };

      dispatch({
        type: JIRA_ISSUE,
        payload: result,
      });
    })
    .catch((e) => {
      console.log("err", e.err);
      dispatch({
        type: JIRA_ISSUE,
        payload: {},
      });
    });
};
export const getJiraProjects = (query: string = "") => (dispatch: any) => {
  const queryParam = query ? "?query=" + encodeURIComponent(query) : "";
  get(PROJECT_URL + queryParam).then((res) => {
    dispatch({
      type: JIRA_PROJECT,
      payload: res ? getResponseBody(res).values : [],
    });
  });
};
const toProjectId = (project: any) => {
  return project?.id === undefined || project?.id === null ? "" : String(project.id);
};

const mergeProjectsById = (currentProjects: any[] = [], incomingProjects: any[] = []) => {
  const uniqueProjects = new Map();
  [...currentProjects, ...incomingProjects].filter(Boolean).forEach((project) => {
    uniqueProjects.set(toProjectId(project), project);
  });
  return Array.from(uniqueProjects.values());
};

export const getJiraProjectById = (id: string) => (dispatch: any, getState: any) => {
  get(PROJECT_URL + "?id=" + encodeURIComponent(id)).then((res) => {
    const projects = res ? getResponseBody(res).values : [];
    dispatch({
      type: JIRA_PROJECT,
      payload: mergeProjectsById(getState()?.jira?.projects, projects),
    });
  });
};
export const getJiraIssueTypesForProject = (projectId: string) => (dispatch: any) => {
  get(JIRA_ISSUE_TYPES_URL + "/project?projectId=" + projectId).then((res) => {
    dispatch({
      type: JIRA_ISSUE_TYPE,
      payload: res ? getResponseBody(res) : [],
    });
  });
};
const getResponseBody = (res: any) => {
  if (IS_DEVELOPMENT) {
    return res;
  }
  return JSON.parse(res.body);
};

export const getJiraUserInfo = () => (dispatch: any) => {
  get(JIRA_USER_GROUPS).then((res) => {
    dispatch({
      type: JIRA_USER_INFO,
      payload: res ? getResponseBody(res) : [],
    });
  });
};
export const lookupAdminPermissionForUser = () => (dispatch: any) => {
  get(JIRA_USER_ADMIN_PERMISSION).then((res) => {
    dispatch({
      type: JIRA_ADMIN_PERMISSION,
      payload: res ? getResponseBody(res) : [],
    });
  });
};
export const setAppWebLocationInJira = () => (dispatch: any) => {
  getAppWebLocationInJira().then((location) => {
    dispatch({
      type: APP_WEB_LOCATION_IN_JIRA,
      payload: location,
    });
  });
};
/**
 * Get the current user from API using AP
 * @param accountId
 * @returns the user
 */
export const getJiraUserByAccountId = (accountId: string) => {
  return get(JIRA_GET_USER_URL + `?accountId=${accountId}`)
    .then((res) => {
      return getResponseBody(res);
    })
    .catch((error) => {
      console.error("Error fetching Jira user:", error);
      return null; // Handle errors gracefully
    });
};
